<template>
    <div ref="box">
        <!-- 头部 -->
        <div class="header">
            <serverHeader
                @reList="getLabelList"
                :listArr="tableList"
            ></serverHeader>
        </div>
        <!-- 表格部分 -->
        <div class="table-content">
            <table-list
                ref="serverTable"
                @deleteAllLabel="deleteAllLabel"
                @refresh="getLabelList"
                :loading="tableLoading"
                :table-list="tableList"
            ></table-list>
        </div>
    </div>
</template>

<script>
// 头部
import serverHeader from "./header.vue";
// 网吧列表
import TableList from "./TableList";

import { delLabelName } from "@/requests/bar";
import { mapActions, mapState } from "vuex";

export default {
    name: "serverLabelManage",
    components: {
        serverHeader,
        TableList
    },
    data() {
        return {
            tableLoading: false
        };
    },
    computed: {
        ...mapState({
            tableList: state => state.serverLabel.serverLabelList
        })
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.getLabelList();
        });
    },
    methods: {
        ...mapActions(["serverLabel/actionUpdateLabelInfo"]),
        // 获取服务器标签列表
        async getLabelList() {
            this.tableLoading = true;
            this["serverLabel/actionUpdateLabelInfo"]();
            this.tableLoading = false;
        },
        deleteAllLabel() {
            if (this.$refs.serverTable.selectedLabelIds().length == 0) {
                return window.$Message.show({
                    title: "提示",
                    type: "info",
                    msg: "请选择服务器标签"
                });
            }
            window.$Message.show({
                title: "删除服务器标签",
                type: "info",
                msg:
                    "是否删除选中的服务器标签？若有服务器正在使用这些标签，则会恢复成“无标签”。",
                cancleBtn: true,
                confirmFn: async () => {
                    let res = await delLabelName({
                        labelId: this.$refs.serverTable
                            .selectedLabelIds()
                            .join(",")
                    });
                    if (res.code === 200) {
                        window.$Message.hide();
                        this.getLabelList(1);
                    } else {
                        window.$Message.hide();
                        setTimeout(() => {
                            window.$Message.show({
                                title: "删除服务器标签",
                                type: "error",
                                msg: res.msg,
                                confirmFn: () => {
                                    window.$Message.hide();
                                    window.$Message.confirmFn = null;
                                }
                            });
                        }, 100);
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";

.header {
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #d9dee4;
}
.table-content {
    padding-top: 10px;
    padding-left: 30px;
    padding-right: 30px;
}
</style>
